export default __webpack_public_path__ + "a831c71d7fe601758170d2903130956a.png";